import {h, Fragment} from "preact"
export default function Skeleton() {
    return (
      <>
        <div className="title-skeleton">
          <div className="results-count-skeleton"></div>
        </div>
        <div className="sidebar-skeleton">
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              key={index}
              className="facet-skeleton"
            ></div>
          ))}
        </div>
        <div className="category-skeleton">
          {Array.from({ length: 12 }).map((_, index) => (
            <div
              key={index}
              className="product-skeleton"
            >
              <CardSkeleton />
            </div>
          ))}
        </div>
      </>
    );
  }
  
  function CardSkeleton() {
    return (
      <>
        <div className="card-skeleton skeleton-image"></div>
        <div className="card-skeleton skeleton-text"></div>
        <div className="card-skeleton skeleton-review"></div>
        <div className="card-skeleton skeleton-price"></div>
      </>
    );
  }
  
  function FacetSkeleton() {
    return (
      <>
        <div className="card-skeleton skeleton-image"></div>
        <div className="card-skeleton skeleton-text"></div>
        <div className="card-skeleton skeleton-text"></div>
        <div className="card-skeleton skeleton-price"></div>
      </>
    );
  }
  